// daoud brand — a subtle cursor-tracked tilt on product photos, layered on top of the
// hover lift (see snippets/daoud-brand-styles.liquid). Desktop/fine-pointer only, and a
// pure enhancement: with this script absent or blocked, .card-gallery still lifts on
// hover via the plain CSS :hover rule, it just doesn't tilt with the cursor.
//
// A previous version drove this with its own requestAnimationFrame spring loop for a
// more physical feel. Reverted: rAF is throttled or fully suspended on a backgrounded/
// unfocused tab (confirmed: document.hidden/hasFocus during testing), so that version
// silently did nothing whenever the tab wasn't the active, focused one — a real failure
// mode, not just a test artifact. Plain custom-property + CSS-transition updates keep
// running regardless of tab focus, so this trades a bit of physical "weight" for
// actually working every time.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(any-pointer: fine)').matches) return;

  var MAX_TILT_DEG = 5;

  function onMove(event) {
    var gallery = event.currentTarget;
    var rect = gallery.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var px = (event.clientX - rect.left) / rect.width;
    var py = (event.clientY - rect.top) / rect.height;
    var rotateY = (px - 0.5) * MAX_TILT_DEG * 2;
    var rotateX = (0.5 - py) * MAX_TILT_DEG * 2;

    gallery.style.setProperty('--daoud-tilt-x', rotateX.toFixed(2) + 'deg');
    gallery.style.setProperty('--daoud-tilt-y', rotateY.toFixed(2) + 'deg');
  }

  function onLeave(event) {
    var gallery = event.currentTarget;
    gallery.style.setProperty('--daoud-tilt-x', '0deg');
    gallery.style.setProperty('--daoud-tilt-y', '0deg');
  }

  function bind() {
    document.querySelectorAll('.card-gallery:not([data-tilt-bound])').forEach(function (gallery) {
      gallery.dataset.tiltBound = 'true';
      gallery.addEventListener('pointermove', onMove);
      gallery.addEventListener('pointerleave', onLeave);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
